import { WindowsAgentClient } from "./WindowsAgentClient"

const PUSH_INTERVAL_MS = 60000

/**
 * Pushes the current Keycloak access token and the store IDs the logged in user is
 * authorized for to the optional local Windows agent, so it can subscribe to
 * /store/{storeId}/orders itself (see WindowsAgentClient). Registered as an
 * onLogin/onLogout handler pair in App.js, same lifecycle as Counter's WS subscription.
 */
export class WindowsAgentAuthBridge {

	_stores
	_myStoreIds = []
	_interval

	constructor(stores) {
		this._stores = stores
	}

	/**
	 * @param {*} getValidTokenPromise
	 * @param {*} user
	 */
	start = (getValidTokenPromise, user) => {
		this._myStoreIds = this._stores.filter(store => user.groups.some(group => {
			const storeMatch = group.match(/\/cook\/(.*)/)
			return storeMatch && storeMatch[1] === store.name
		})).map(store => store.id)

		this._push(getValidTokenPromise)
		clearInterval(this._interval)
		this._interval = setInterval(() => this._push(getValidTokenPromise), PUSH_INTERVAL_MS)
	}

	stop = () => clearInterval(this._interval)

	_push = getValidTokenPromise => {
		getValidTokenPromise()
			.then(token => WindowsAgentClient.authorize(token, this._myStoreIds))
			.catch(() => {})
	}

}
